import '../../../../packages/frontend/components/arti24/arti24.js';
import '../../../../packages/frontend/components/arti24/arti24-stats-link.js';
import { bindContactForms } from '../../../../packages/frontend/forms/contact-form-submit.js';

bindContactForms();
